import axios from 'axios';
import { SubscribeRequest, SubscribeResponse } from '@/types/api';

export const subscribe = (url: string, data: SubscribeRequest): Promise<SubscribeResponse> =>
    axios.post(url + '?action=add-alert', data)
        .then(response => response.data);
